import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="h-10 bg-[#EA33C0] flex items-center justify-center text-white text-xs sm:text-sm px-2">
      © 2026 MediaBridge. All rights reserved.
    </footer>
  );
};

export default Footer;